/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ConversationInfoMessage
 */
export interface ConversationInfoMessage {
    /**
     * 
     * @type {string}
     * @memberof ConversationInfoMessage
     */
    'message_type'?: ConversationInfoMessageMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversationInfoMessage
     */
    'severity'?: ConversationInfoMessageSeverityEnum;
}

export const ConversationInfoMessageMessageTypeEnum = {
    owner_has_not_responded: 'owner_has_not_responded'
} as const;

export type ConversationInfoMessageMessageTypeEnum = typeof ConversationInfoMessageMessageTypeEnum[keyof typeof ConversationInfoMessageMessageTypeEnum];
export const ConversationInfoMessageSeverityEnum = {
    info: 'info',
    warning: 'warning',
    critical: 'critical'
} as const;

export type ConversationInfoMessageSeverityEnum = typeof ConversationInfoMessageSeverityEnum[keyof typeof ConversationInfoMessageSeverityEnum];


